import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "./../../redux/actions/commonAction";

const CustomSnackbar = () => {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector(
    (state) => state.common.snackbar
  );
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={3000}
      onClose={() => dispatch(showSnackbar({ open: false }))}
    >
      <Alert
        elevation={6}
        variant="filled"
        sx={{ width: "100%" }}
        onClose={() => dispatch(showSnackbar({ open: false }))}
        severity={severity}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
